import { ButtonTertiary } from "components/Atoms/Button";
import { PreferredTemplatePill } from "components/Pill/PreferredTemplatePill";
import { BasicTemplatePill } from "components/Pill/BasicTemplatePill";
import React from "react";
import { localizedLanguageSort } from "utilities/translationUtils";

interface Props {
  template: server.dto.MessageTemplate
  onTemplateSelected: (template: server.dto.MessageTemplate, language: server.dto.Languages) => void
}

const languageToLabelMap = new Map<server.dto.Languages, string>();
serverReference.languages.forEach(lang => languageToLabelMap.set(lang.value, lang.localizedName));

export const TemplateCard = (props: Props) => {

  return <div className="flex padding gray-100 radius">
    <div className="flex-column gap grow1">
      <div>{props.template.title}</div>

      <div className="flex gap" style={{ flexWrap: "wrap" }}>
        {[...props.template.implementedLanguages].sort(localizedLanguageSort).map(lang => (
          <ButtonTertiary
            key={lang}
            onClick={() => props.onTemplateSelected(props.template, lang)}
            label={languageToLabelMap.get(lang)}
          />
        ))}
      </div>
    </div>
    <div>
      {props.template.basicTemplate && <BasicTemplatePill />}
      {props.template.preferredTemplate && <PreferredTemplatePill />}
    </div>
  </div>
}
